var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.393 23.997C17.0321 25.3162 15.5462 25.1079 14.1158 24.483C12.6021 23.8442 11.2134 23.8164 9.61636 24.483C7.61661 25.344 6.56119 25.0941 5.3669 23.997C-1.41002 17.0117 -0.41015 6.3742 7.28332 5.98536C9.15809 6.08257 10.4635 7.013 11.5606 7.09633C13.1992 6.76303 14.7685 5.80482 16.5183 5.92981C18.6152 6.09645 20.1984 6.92968 21.2399 8.42949C16.9071 11.0264 17.9348 16.734 21.9065 18.331C21.1149 20.4141 20.0873 22.4833 18.3791 24.0109L18.393 23.997ZM11.4217 5.90203C11.2134 2.8052 13.727 0.249968 16.6155 0C17.0182 3.58288 13.3659 6.24921 11.4217 5.90203Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMac);
export default __webpack_public_path__ + "static/media/iconMac.38e6b59ebd92579af7782c9097ea8015.svg";
export { ForwardRef as ReactComponent };